import React, { useEffect, useState } from "react";
import { applyActionCode } from "firebase/auth";
import { Segment } from "semantic-ui-react";
import tick from "../../../assets/icons/success-tick.svg";
import logo from "../../../assets/icons/logo-white.svg";

export default function VerifyEmailHandler({
  isVerified = false,
  auth,
  actionCode,
}) {
  const [isLoading, setIsLoading] = useState(false);
  const [verified, setVerified] = useState(isVerified);
  const [isAlreadyVerified, setIsAlreadyVerified] = useState(false);

  useEffect(() => {
    if (isVerified) return;

    async function verifyEmail() {
      return applyActionCode(auth, actionCode);
    }

    setIsLoading(true);
    verifyEmail()
      .then(() => {
        setVerified(true);
        console.log("verified");
      })
      .catch(() => setIsAlreadyVerified(true))
      .finally(() => setIsLoading(false));
  }, [actionCode, auth, isVerified]);

  return (
    <Segment
      loading={isLoading}
      padded={true}
      textAlign="center"
      style={{ padding: 0, borderRadius: 12 }}
    >
      {!isLoading && (
        <>
          <div
            className="sign-up-strapline-container"
            style={{ borderRadius: "12px 12px 0 0", marginBottom: 25 }}
          >
            <img
              className="hello-radius-logo"
              src={logo}
              alt="hello radius"
              data-testid="hello-radius-logo-image-testid"
            />
          </div>
          <div className="post-action-image-container">
            <img className="modal-confirm-tick-logo" src={tick} alt="tick" />
          </div>
          <div style={{ fontSize: 22, marginBottom: 20 }}>
            {isAlreadyVerified && "Your email has been verified"}
            {verified && "Success! Email verified"}
          </div>
          {verified && (
            <div
              className={"body-blue-text"}
              style={{ padding: "0 30px", marginBottom: 30 }}
            >
              Your email was verified. Please return to the device or browser
              tab where you began sign up and click "I have verified my email"
              to login.
            </div>
          )}
        </>
      )}
      {isLoading && <div style={{ height: 100 }} />}
    </Segment>
  );
}
